// packages/shared/src/map/codec.ts — tile byte codec and MapData ↔ MapPayload (§7.8)
import { base64ToBytes, bytesToBase64 } from '../base64';
import { GROUND, type Ground, type MapData, type MapPayload, type Tier } from '../types/map';
type Grid = Pick<MapData, 'w' | 'h' | 'tiles'>;
const BY_CODE: readonly Ground[] = ['grass', 'sand', 'river', 'pond', 'sea', 'cliff', 'path', 'ramp'];
const inside = (m: Grid, x: number, y: number) => x >= 0 && y >= 0 && x < m.w && y < m.h;
export function tileByte(ground: Ground, tier: Tier, rampDir: 0 | 1 | 2 | 3 = 0): number {
  return GROUND[ground] | (tier << 4) | ((ground === 'ramp' ? rampDir : 0) << 6);
}
export function groundAt(map: Grid, x: number, y: number): Ground {
  return inside(map, x, y) ? (BY_CODE[map.tiles[y * map.w + x]! & 0x0f] ?? 'sea') : 'sea';
}
export function tierAt(map: Grid, x: number, y: number): Tier {
  return inside(map, x, y) ? (((map.tiles[y * map.w + x]! >> 4) & 0x03) as Tier) : 0;
}
export function rampDirAt(map: Grid, x: number, y: number): 0 | 1 | 2 | 3 | null {
  return groundAt(map, x, y) === 'ramp' ? (((map.tiles[y * map.w + x]! >> 6) & 0x03) as 0 | 1 | 2 | 3) : null;
}
export function toPayload(map: MapData): MapPayload { return { ...map, tiles: bytesToBase64(map.tiles) }; }
export function fromPayload(p: MapPayload): MapData { return { ...p, tiles: base64ToBytes(p.tiles) }; }
